import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  CircularProgress
} from '@mui/material';
import { DeleteForever as DeleteIcon } from '@mui/icons-material';

interface UserDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  username: string;
  displayName: string;
  deleting: boolean;
  onConfirm: () => void;
}

export const UserDeleteDialog: React.FC<UserDeleteDialogProps> = ({
  open,
  onClose,
  username,
  displayName,
  deleting,
  onConfirm
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { borderRadius: '12px', p: 1 } }}
    >
      <DialogTitle sx={{ fontWeight: 700, color: '#0f172a' }}>
        Подтверждение удаления пользователя
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          Вы действительно хотите безвозвратно удалить пользователя <strong>{username}</strong> ({displayName})?
        </Typography>
        <Typography variant="body2" color="error" sx={{ mt: 1, fontWeight: 500 }}>
          Это действие удалит персональную таблицу базы данных и не может быть отменено!
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button
          onClick={onClose}
          sx={{ textTransform: 'none', fontWeight: 600, borderRadius: '6px' }}
        >
          Отмена
        </Button>
        <Button
          variant="contained"
          color="error"
          disabled={deleting}
          onClick={onConfirm}
          startIcon={deleting ? <CircularProgress size={16} /> : <DeleteIcon />}
          sx={{ textTransform: 'none', fontWeight: 600, borderRadius: '6px', bgcolor: '#e11d48' }}
        >
          {deleting ? 'Удаление...' : 'Да, удалить'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserDeleteDialog;
